import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propStr } from '../../../../../helpers/custom-prop-types';
const InputTitle = ({ isRequired, label, tip }) => (_jsxs("h3", { children: [label, isRequired && _jsx("span", Object.assign({ className: 'necessary font-size-0-8rem' }, { children: "*\u5FC5\u9808" })), tip && (_jsx("div", Object.assign({ className: 'supplement-box' }, { children: _jsxs("span", { children: [_jsx("i", Object.assign({ className: 'material-icons md-14' }, { children: "info" })), tip] }) })))] }));
InputTitle.propTypes = {
    isRequired: propBool().isRequired,
    label: propStr().isRequired,
    tip: propStr().isRequired,
};
export default InputTitle;
